import type { LoggerUserContext } from '@zep/logger';

import { type UserInfo } from '@/types/UserInfo';

export const createLoggerUserContext = (user: UserInfo): LoggerUserContext => ({
  userId: user.email,
  properties: createCommonUserProperties(user),
  integrations: {
    sentry: createSentryUser(user),
  },
});

const createCommonUserProperties = (user: UserInfo) => ({
  email: user.email,
  username: user.username,
  isAdmin: user.admin,
  // MongoDB `quiz-real.users._id` (ObjectId hex). 텔레메트리의 나머지 유저 식별자는
  // 전부 평문 이메일이라 MongoDB(encryptedEmail)와 조인할 수 없다. 이 값이 유일한
  // 조인키다 — boards.ownerId·quizsets.author.id·playerHistories.quizUserId 가 같은 값.
  quizUserId: user.quizUserId,
  // user.type 은 앱 내부에선 소문자 union 이지만, 텔레메트리/대시보드는 기존 대문자
  // (STUDENT/TEACHER/...) 포맷을 유지한다.
  userType: user.type?.toUpperCase(),
  planType: user.planType,
  zep_user_country_code: user.countryCode,
  isPro: user.planType === 'PRO',
  IS_LOGIN: true,

  //hyperdx 유저 속성 설정을 위해 임시로 다음의 필드를 추가합니다.
  userEmail: user.email,
  userId: user.email,
});

const createSentryUser = (user: UserInfo) => ({
  email: user.email,
  username: user.username,
  isAdmin: user.admin,
  // user.type 은 앱 내부에선 소문자 union 이지만, 텔레메트리/대시보드는 기존 대문자
  // (STUDENT/TEACHER/...) 포맷을 유지한다.
  userType: user.type?.toUpperCase(),
  planType: user.planType,

  //hyperdx 유저 속성 설정을 위해 임시로 다음의 필드를 추가합니다.
  userEmail: user.email,
  userId: user.email,
});
